export type ThisWeekItem = {
  id: number;
  type: 'mommy-mingle' | 'local-event' | 'outing' | 'member-perk';
  tag: string;
  title: string;
  detail: string;
  /** Full day name e.g. "Tuesday" or "Saturday". Use "Any" for flexible outings. Omit for member-perk. */
  day?: string;
  /** Display time string e.g. "10:00 AM" */
  time?: string;
  /** 24-hour start hour for calendar export, e.g. 10 */
  startHour?: number;
  /** Duration in minutes for calendar export */
  durationMins?: number;
  location?: string;
  link?: string;
  linkLabel?: string;
};

export const thisWeekItems: ThisWeekItem[] = [
  {
    id: 1,
    type: 'mommy-mingle',
    tag: 'Mommy Mingle Event',
    title: 'Playground Playdate — Vines Park',
    detail: 'Bring the kids and come hang. No agenda, just good vibes and a chance to meet other local moms.',
    day: 'Tuesday',
    time: '10:00 AM',
    startHour: 10,
    durationMins: 90,
    location: 'Vines Park, Loganville',
    link: '/events',
    linkLabel: 'RSVP',
  },
  {
    id: 2,
    type: 'local-event',
    tag: 'Local Event',
    title: 'Story Time at Gwinnett Library',
    detail: 'Free drop-in story time for little ones ages 2–5. Great for a weekday morning outing.',
    day: 'Wednesday',
    time: '10:30 AM',
    startHour: 10,
    durationMins: 60,
    location: 'Gwinnett County Public Library',
    link: 'https://www.gwinnettpl.org',
    linkLabel: 'Get Details',
  },
  {
    id: 3,
    type: 'local-event',
    tag: 'Local Event',
    title: 'Lawrenceville Farmers Market',
    detail: 'Stock up on fresh produce, grab a coffee, and let the kids roam. A chill weekend staple.',
    day: 'Saturday',
    time: '8:00 AM – Noon',
    startHour: 8,
    durationMins: 240,
    location: 'Lawrenceville Square',
    link: 'https://www.lawrencevillega.org',
    linkLabel: 'Get Details',
  },
  {
    id: 4,
    type: 'outing',
    tag: 'Easy Outing Idea',
    title: 'Quick Win: Tribble Mill Park',
    detail: 'Wide open trails, a playground, and a lake — no planning needed. Just pack snacks and go.',
    day: 'Any',
    startHour: 10,
    durationMins: 120,
    location: 'Tribble Mill Park, Lawrenceville',
    link: 'https://www.gwinnettcounty.com/parks',
    linkLabel: 'See More Parks',
  },
  {
    id: 5,
    type: 'member-perk',
    tag: 'Member Perk',
    title: 'Member Perk',
    detail: 'Get early access to event RSVPs before they go public.\n\nSkip the wait and secure your spot first.',
    link: '/membership',
    linkLabel: 'Unlock Early Access',
  },
];
